module.exports = __webpack_public_path__ + "media/images/logos/University-of-Pennsylvania-1e440ca48bde24ca33d8b2c81591fba1.svg";